import { fetchAPI, sendNotification } from '@bsd/dashboard-toolkit/utils'


export const openModal = () => async (dispatch) => {
  dispatch({ type: 'OPEN_SECTION_MODAL' })
}

export const closeModal = () => async (dispatch) => {
  dispatch({ type: 'CLOSE_SECTION_MODAL' })
}

export const selectSection = (e, { value }) => async (dispatch) => {
  dispatch({ type: 'SELECT_SECTION', sectionId: value })
}

export const loadGeoSection = (sectionId) => async (dispatch) => {
  dispatch({ type: 'LOAD_GEO_SECTION' })
  try {
    const section = await fetchAPI(`/in/globe3d/geo-sections/${sectionId}`)
    dispatch({ type: 'LOAD_GEO_SECTION_SUCCESS', section })
  } catch (error) {
    dispatch({ type: 'LOAD_GEO_SECTION_FAIL', error })
  }
}

export const loadGeoSections = () => async (dispatch) => {
  dispatch({ type: 'LOAD_GEO_SECTIONS' })
  try {
    const sections = await fetchAPI(`/in/globe3d/geo-sections`)
    dispatch({ type: 'LOAD_GEO_SECTIONS_SUCCESS', sections })
  } catch (error) {
    dispatch({ type: 'LOAD_GEO_SECTIONS_FAIL', error })
  }
}

export const createGeoSection = (data) => async (dispatch) => {
  dispatch({ type: 'CREATE_GEO_SECTION' })
  try {
    const section = await fetchAPI(`/in/globe3d/geo-sections`, 'POST', data)
    dispatch({ type: 'CREATE_GEO_SECTION_SUCCESS', section })
    sendNotification({ level: 'success', message: 'Раздел успешно создан' })
    dispatch({ type: 'CLOSE_SECTION_MODAL' })
    return section
  } catch (error) {
    dispatch({ type: 'CREATE_GEO_SECTION_FAIL', error })
    sendNotification({ level: 'error', message: 'При создании произошла ошибка' })
  }
}

export const updateGeoSection = (sectionId, data) => async (dispatch) => {
  dispatch({ type: 'UPDATE_GEO_SECTION' })
  try {
    const section = await fetchAPI(`/in/globe3d/geo-sections/${sectionId}`, 'PUT', data)
    dispatch({ type: 'UPDATE_GEO_SECTION_SUCCESS', section })
    sendNotification({ level: 'success', message: 'Раздел успешно обновлен' })
    dispatch({ type: 'CLOSE_SECTION_MODAL' })
  } catch (error) {
    dispatch({ type: 'UPDATE_GEO_SECTION_FAIL', error })
    sendNotification({ level: 'error', message: 'При обновлении произошла ошибка' })
  }
}

export const deleteGeoSection = (sectionId) => async (dispatch) => {
  dispatch({ type: 'DELETE_GEO_SECTION' })
  try {
    await fetchAPI(`/in/globe3d/geo-sections/${sectionId}`, 'DELETE')
    dispatch({ type: 'DELETE_GEO_SECTION_SUCCESS', sectionId })
    sendNotification({ level: 'success', message: 'Раздел успешно удален' })
    dispatch({ type: 'CLOSE_SECTION_MODAL' })
  } catch (error) {
    dispatch({ type: 'DELETE_GEO_SECTION_FAIL', error })
    sendNotification({ level: 'error', message: 'При удалении произошла ошибка' })
  }
}
